import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';

const { OutlinedPencilIcon } = OutlinedIcons;

type EditButtonProps = {
  onEdit: () => void;
};

const EditButton = ({ onEdit }: EditButtonProps) => (
  <Tooltip title="Edit">
    <span>
      <IconButton
        color="primary"
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          e.preventDefault();
          onEdit();
        }}
      >
        <OutlinedPencilIcon />
      </IconButton>
    </span>
  </Tooltip>
);

export default EditButton;
